// Lazy loads videos with class '.lazy' using IntersectionObserver
export const lazyLoadVideos = function () {
    const lazyVideos = [].slice.call(document.querySelectorAll('video.lazy'))

    if ('IntersectionObserver' in window) {
        const lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach((video) => {
                if (video.isIntersecting) {
                    for (const source in video.target.children) {
                        const videoSource = video.target.children[source]
                        if (
                            typeof videoSource.tagName === 'string' &&
                            videoSource.tagName === 'SOURCE'
                        ) {
                            videoSource.src = videoSource.dataset.src
                        }
                    }

                    video.target.load()
                    lazyVideoObserver.unobserve(video.target)
                    if (video.target.dataset.autoplay !== undefined) {
                        video.target.play()
                    }
                }
            })
        })

        lazyVideos.forEach((lazyVideo) => {
            lazyVideoObserver.observe(lazyVideo)
        })
    } else {
        // Do not lazy load videos if IntersectionObserver is not supported
        lazyVideos.forEach((lazyVideo) => {
            for (const source in lazyVideo.children) {
                const videoSource = lazyVideo.children[source]
                if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
                    videoSource.src = videoSource.dataset.src
                }
            }
            lazyVideo.load()
            if (lazyVideo.dataset.autoplay !== undefined) {
                lazyVideo.play()
            }
        })
    }
}

/**
 * Loads videos with class '.defer' after the rest of the page is loaded
 */
export const deferLoadVideos = () => {
    const videos = document.querySelectorAll('video.defer')
    videos.forEach((video) => {
        for (const source in video.children) {
            const videoSource = video.children[source]
            if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
                videoSource.src = videoSource.dataset.src
            }
        }
        video.load()
        if (video.dataset.autoplay === 'true') {
            video.setAttribute('autoplay', '')
            video.play()
        }
    })
}

/**
 * Handle the toggle video button
 * @param {Event} event - The click event
 */
export const handleToggleVideo = (event) => {
    const target = document.getElementById(event.currentTarget.getAttribute('aria-controls'))

    if (!target) {
        return
    }

    if (event.currentTarget.dataset.action === 'play') {
        target.play()
        target.controls = true
        gsap.to(event.currentTarget, {
            scale: 0.5,
            autoAlpha: 0,
            duration: 0.5,
            onComplete: () => {
                event.currentTarget.closest('.btn-wrapper').style.display = 'none'
            },
        })
    } else {
        if (target.paused) {
            target.play()
        } else {
            target.pause()
        }
    }
}

/**
 * Setup event listeners to play/pause the cover video on click
 * * @param {HTMLVideoElement} videoEl - The video element to control (optional, defaults to the cover video)
 */
export const setupPlayPauseCoverVideo = (videoEl) => {
    const video = videoEl || document.querySelector('#cover > .cover-background > video')

    document.querySelector('.cover-body')?.addEventListener('click', function (event) {
        if (event.target !== this || video === null) {
            // Only trigger if the click was on the parent, not on the children
            return
        }
        video.paused ? video.play() : video.pause()
    })
    document.querySelector('#pause-cover-bg-video')?.addEventListener('click', function () {
        if (video.paused) {
            video.play()
            this.setAttribute('aria-pressed', 'false')
        } else {
            video.pause()
            this.setAttribute('aria-pressed', 'true')
        }
    })
}
